import React from 'react'

import { Field } from 'formik'

import { Form, Col, Button } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

import { NuevoActualizarTablaPersonalizadaModal } from 'sharedComponents/modals'

const IdSubServicio1FormGroup = ({ iError, iTouched, fIsSubmitting, handleChange, setFieldValue, vIdServicio }) => {
  const [subServicios1, setSubServicios1] = React.useState([])
  const [mostrarModalCrud, setMostrarModalCrud] = React.useState(false)

  React.useEffect(() => {
    if (vIdServicio) {
      TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.TALLERSUBSERVICIO1, {
        _idServicio: vIdServicio
      }).then(({ data }) => {
        setSubServicios1(data)
      })
    } else {
      setSubServicios1([])
    }
  }, [vIdServicio])

  const onSuccess = React.useCallback(async () => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.TALLERSUBSERVICIO1, {
      _idServicio: vIdServicio
    }).then(({ data }) => {
      setSubServicios1(data)
    })
    setMostrarModalCrud(false)
  }, [vIdServicio])

  const onChange = React.useCallback(
    e => {
      handleChange(e)
      setFieldValue('_idSubServicio2', '')
    },
    [handleChange, setFieldValue]
  )

  return (
    <>
      <Form.Group>
        <Form.Label text='SUB SERVICIO 1' htmlFor='select-idSubServicio1' md={2} alignRightAt='md' />
        <Col md={10}>
          <Form.InputGroup>
            <Field name='_idSubServicio1'>
              {({ field }) => (
                <Form.Select {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-idSubServicio1' onChange={onChange}>
                  <option key='seleccionar' value=''>
                    Seleccionar
                  </option>
                  {subServicios1.map(x => (
                    <option key={x._id} value={x._id}>
                      {x.nombre}
                    </option>
                  ))}
                </Form.Select>
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button onClick={() => setMostrarModalCrud(true)}>+</Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarModalCrud && (
        <NuevoActualizarTablaPersonalizadaModal
          handleClose={e => setMostrarModalCrud(false)}
          show={mostrarModalCrud}
          modalData={{
            _idServicio: vIdServicio
          }}
          onSuccess={onSuccess}
          tipoTabla={TiposTablaPersonalizadaConstant.TALLERSUBSERVICIO1}
        />
      )}
    </>
  )
}

export default React.memo(IdSubServicio1FormGroup)
